export enum EMode {
    dateTime = 'date-time',
}

export interface IProps {
    mode: EMode
    availableDates: Date[]|undefined,
    presetDate: Date|undefined
    callbackOnPickDate: (date: Date|undefined) => void
}
